
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"182.73","height":"159.589","viewBox":"0 0 182.73 159.589"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 542","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"10"}},[_c('path',{attrs:{"data-name":"Pfad 464","d":"M163.632 130.174l14.1 24.414H5.002l43.183-74.795L91.368 4.999l43.183 74.794 12.254 21.225"}}),_c('path',{attrs:{"data-name":"Linie 9","d":"M91.365 58.125v40.46"}}),_c('path',{attrs:{"data-name":"Linie 10","d":"M91.365 128.565v-7.978"}})])])
          )
        }
      }
    